import { render, staticRenderFns } from "./RoomBottomNav.vue?vue&type=template&id=7ad81926&scoped=true&"
import script from "./RoomBottomNav.vue?vue&type=script&lang=js&"
export * from "./RoomBottomNav.vue?vue&type=script&lang=js&"
import style0 from "./RoomBottomNav.vue?vue&type=style&index=0&id=7ad81926&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad81926",
  null
  
)

component.options.__file = "RoomBottomNav.vue"
export default component.exports